import React from 'react';
import router from 'next/router';
import styles from "../../styles/components/offeringCard.module.scss";


export default function index(props) {
   //console.log(props, "offeringcard")

   const { field_background_image,field_title,field_description,field_link,pdf_link  } = props.data

   const handleClick = ()=>{
    props.setPdfModal(true);
    props.setPdfUrl(pdf_link);
    props.setPdfTitle(field_title);
   }

  return (
   <div className={styles.cardContainer}>
       <div className={styles.card}>
           <div className={styles.image}>
               <img src={field_background_image} alt= "img"/>
           </div>
           <div className={styles.head}>
          {field_title}

           </div>
           <div className={styles.desc}>
           {field_description}
           </div>
           <div className={styles.knowMore} onClick={()=>handleClick()} >
             {field_link}
           </div>
       </div>
   </div>
  );
}
